let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aE4di")).then(() => parcelRequire('k8wt9'));